module.exports = __webpack_public_path__ + "img/gu.gu43b1420.svg";